import { render, staticRenderFns } from "./DocumentsShow.vue?vue&type=template&id=7528376d&"
import script from "./DocumentsShow.vue?vue&type=script&lang=js&"
export * from "./DocumentsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports